import { render } from "./CoBrandThemeClassic.vue?vue&type=template&id=d8fdff80&scoped=true"
import script from "./CoBrandThemeClassic.vue?vue&type=script&lang=js"
export * from "./CoBrandThemeClassic.vue?vue&type=script&lang=js"

import "./CoBrandThemeClassic.vue?vue&type=style&index=0&id=d8fdff80&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d8fdff80"]])

export default __exports__